export enum VerfuegungMessages {
	ASK_TO_VERFUEGUNG_UEBERGEBEN = 'Wollen Sie die Verfügung an die Geschäftsstelle übergeben?',
	DELETE_VERFUEGUNG = 'Wollen Sie diese Verfügung wirklich löschen?',
}

export enum VerfuegungStatusLabel {
	OFFEN = 'Offen',
	ERLEDIGT = 'Erledigt',
}
